import { Link } from '@tanstack/react-router';
import { Scale } from 'lucide-react';
import { REGULATORY_CROSS_LINK_LINE, REGULATORY_REGISTER_ANCHOR_ID } from './regulationCopy';

/**
 * SIL-611 — the one-line pointer to the Regulatory register, rendered at the
 * top of every environmental surface that shows disposal / end-of-life flows.
 *
 * Deliberately NOT the amber notice treatment used elsewhere in this portal
 * (`border-amber-200 bg-amber-50`, e.g. ScenarioBuyMoveStep:300). Amber reads
 * as "something is wrong with your data" — but this line is informational, and
 * the whole SIL-611 copy discipline is that SiliconX holds no determination of
 * the customer's compliance. Prominence comes from the border, fill, icon, and
 * weight; the alarm colour is reserved for the register's own penalty row.
 *
 * The label text is legally signed off (see
 * `resources/plans/sil-611-regulation-reference-copy.md` §5) — render
 * `REGULATORY_CROSS_LINK_LINE` verbatim, never a reworded variant. The copy
 * already ends in "→", so no trailing arrow icon is added.
 */
export function RegulatoryRegisterLink({ className = '' }: { className?: string }) {
  return (
    <Link
      to="/environmental/reports"
      hash={REGULATORY_REGISTER_ANCHOR_ID}
      className={`flex items-center gap-2 rounded-md border border-brand-200 bg-brand-50 px-3 py-2 text-xs font-semibold text-brand-800 transition-colors hover:bg-brand-100 ${className}`}
      data-testid="cross-link-regulatory-register"
    >
      <Scale className="size-4 shrink-0 text-brand-700" aria-hidden="true" />
      <span>{REGULATORY_CROSS_LINK_LINE}</span>
    </Link>
  );
}
